import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class MattersAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      moodle_id: '',
      short_name: '',
      avaliation: 0,
      hours_time: '',
      reference: '',
      grade: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.adicionar = this.adicionar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  adicionar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      moodle_id: this.state.moodle_id,
      name: this.state.name,
      short_name: this.state.short_name,
      avaliation: this.state.avaliation,
      hours_time: this.state.hours_time,
      reference: this.state.reference,
      grade: this.state.grade,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/materia/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar matéria</h3>
      <Link to="/materias" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>          
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome da matéria:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome da Matéria" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome Curto:</label>
              <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Necessita de Avaliação?</label>
              <Select
                className="form-field-name"
                name="avaliation"
                value={this.state.avaliation}
                searchable={true}
                placeholder={false}
                onChange={this.handleSelectChange.bind(this, 'avaliation')}
                options={[
                  {value: 0, label: "Não"},
                  {value: 1, label: "Sim"},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Carga horária:</label>
              <InputMask value={this.state.hours_time}  maskChar={null} name="hours_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hours_time')} placeholder="Informe a carga horária no formato hh:mm" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nota mínima:</label>
              <input type="grade" name="grade" disabled={this.state.avaliation === 0 ? "disabled" : ""} className="form-control" placeholder="Nota Mínima" value={this.state.grade} onChange={this.handleChange.bind(this, 'grade')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>ID Curso Moodle:</label>
              <input type="text" name="moodle_id" className="form-control" placeholder="ID do curso padrão no Moodle" value={this.state.moodle_id} onChange={this.handleChange.bind(this, 'moodle_id')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Referência:</label>
              <textarea style={{ height: 200 }} type="text" name="reference" className="form-control" value={this.state.reference} onChange={this.handleChange.bind(this, 'reference')} />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar matéria</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default MattersAdd;



// WEBPACK FOOTER //
// ./src/Components/Matters/MattersAdd.js